import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

import LdsButton from "../../components/LdsButton";
import { SideBar } from "../../components/SideBar";
import { useSelector } from "react-redux";

import { ReactLoaderSpinner } from "../../components/ReactLoaderSpinner/index.js";
// services
import { useBookmarkModuleMutation } from "../../store/services/moduleServerApi";
import ModuleQuestion from "../../components/ModuleQuestion";

const Module_1_0 = () => {
  const { pathname: pathName } = useLocation();
  const { menuItems } = useSelector((state) => state?.moduleSlice);

  const [bookmarkModule, { isLoading: isMenuLoading }] =
    useBookmarkModuleMutation();

  /* Start useEffect */
  useEffect(() => {
    bookmarkModule({ pathName });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // * onPageLoad
  /* End useEffect */

  return (
    <div className="row">
      {isMenuLoading && <ReactLoaderSpinner />}
      {menuItems?.id && <SideBar menuItems={[menuItems]} />}

      <main className="col-sm-8 module-content">
        <section>
          <h1 className="blue text-uppercase b mt-5 mb-4">3.0.8 Case 8</h1>
          <p className="me-4">Estimated time to complete: 3-5 minutes</p>
        </section>
        <ModuleQuestion
          correctAnswer="A"
          assessmentName="self_assessment_108"
          videoTranscript={
            <>
              <p>
                <strong>AUDIO</strong>
                <br />
                VO: (FEMALE)
                <br />
                This is self-assessment case number 8. This is a positive case.
                Beginning at the level of the cerebellum and scrolling
                superiorly, we immediately see the left and right temporal
                lobes. Increased activity can be seen in the right temporal
                lobe, but it is important to review the slices superior to
                ensure that the increased activity is within the cortical gray
                matter. In this particular slice, it is clear that the intense
                uptake extends to the cortical rim on the right-hand side. On
                the left-hand side, this pattern is also seen. White matter
                tracts are not clearly identifiable in the left or right
                temporal lobes. Continuing to scroll superiorly, we enter into
                the occipital lobes. White matter tracts can be seen on the left
                and right, and there is preserved gray-white contrast, although
                it is borderline. Again moving superiorly and entering into the
                frontal cortices, it is clear that white matter tracts cannot be
                seen on the left or the right. Increased activity is seen
                throughout the gray matter in both frontal cortices, and there
                is complete loss of gray-white contrast. At the level of the
                parietal lobes on the right-hand side, white matter tracts may
                be seen on the right-hand side, seen here. However, on the
                left-hand side, white matter tracts cannot be clearly
                identified. In addition, increased activity is seen in the
                medial parietal region, located here. This region, including the
                precuneus, which can be further localized using the sagittal
                images, show increased activity within the cortical gray matter,
                seen here. There is loss of gray-white contrast throughout the
                medial parietal region. Continuing to scroll superiorly, and
                reviewing all the slices within the scan, it is clear that there
                is loss of gray-white contrast, not only in the parietal region,
                but also in the frontal and temporal lobes. Therefore, this case
                is positive. If you called this case negative, I invite you to
                review the case in the MIM Viewer, concentrating on the regions
                described.
              </p>
            </>
          }
          previousLesson="/module-3/module-3-0-7"
          nextLesson="/module-3/module-3-0-9"
          iframeURL="https://cdnapisec.kaltura.com/p/1759891/sp/175989100/embedIframeJs/uiconf_id/24639831/partner_id/1759891?iframeembed=true&playerId=kaltura_player_335433249&entry_id=1_i3bw3220&wid=_1759891&flashvars[sideBarContainer.plugin]=true&flashvars[sideBarContainer.position]=left&flashvars[sideBarContainer.clickToClose]=true&flashvars[chapters.plugin]=true&flashvars[chapters.layout]=vertical&flashvars[chapters.thumbnailRotator]=false&flashvars[streamSelector.plugin]=true&flashvars[EmbedPlayer.SpinnerTarget]=videoHolder&flashvars[dualScreen.plugin]=true"
          questionType="assessment"
          videoId="1_i3bw3220"
        />
      </main>
    </div>
  );
};

export default Module_1_0;
